<div class="dialog">
    <div class="dialog-header">
        编卷
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page" [style.width]="100 + 'px'">
                    分卷方式
                </div>
                <div class="column" [style.width]="300 + 'px'">
                    <select [(ngModel)]="record.createType" (ngModelChange)="onBatchChange()">
                        <option [value]="ArchiveVolumeCreateType.MANUAL">
                            手动分卷
                        </option>
                        <option [value]="ArchiveVolumeCreateType.AUTO_BATCH" [disabled]="!canBatch">
                            自动批量分卷
                        </option>
                    </select>
                </div>
                <div class="column" [style.width]="300 + 'px'">
                    <select
                        class="{{record.createType === ArchiveVolumeCreateType.AUTO_BATCH && !batchRule ? 'color-danger' : ''}}"
                        [(ngModel)]="batchRule" [disabled]="record.createType !== ArchiveVolumeCreateType.AUTO_BATCH"
                        (ngModelChange)="onBatchRuleChange()">
                        <option [value]="''" [disabled]="true">选择分卷规则</option>
                        <option *ngFor="let item of BatchArchiveVolumeRuleList" [value]="item.value">
                            {{item.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row {{record.volumePageType !== ArchiveVolumePageType.UNLIMITED ? 'validate' : ''}}">
                <div class="column background-page" [style.width]="100 + 'px'">
                    分卷页数
                </div>
                <div class="column background-module" [style.width]="300 + 'px'">
                    <select [(ngModel)]="record.volumePageType" (ngModelChange)="onPageLimitChange()">
                        <option [value]="undefined" [disabled]="true">选择页面限制</option>
                        <option *ngFor="let item of ArchiveVolumePageTypeOptions" [value]="item.value">
                            {{item.label}}
                        </option>
                    </select>
                </div>
                <div class="column color-light background-module" [style.width]="20 + 'px'">
                    ≤
                </div>
                <div class="column no-border-left background-module" [style.width]="100 + 'px'">
                    <input type="text" placeholder="输入页数" appDigitalFormat [(ngModel)]="record.volumePageLimit"
                        [disabled]="record.volumePageType !== ArchiveVolumePageType.LIMITED">
                </div>
                <div class="column no-border-left background-module" [style.width]="180 + 'px'">
                    页
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    保管期限
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <select [(ngModel)]="record.keepPeriodType">
                        <option *ngFor="let item of ArchiveKeepPeriodTypeOptions" [value]="item.value">
                            {{item.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 卷内排序
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <nz-select class="{{sortOrder.length === 0 ? 'invalidate' : ''}}" [(ngModel)]="sortOrder"
                        [nzOptions]="ArchiveOrderFieldOptions" nzMode="multiple" [nzPlaceHolder]="'请选择排序方式'"
                        (ngModelChange)="onOrderSelected()">
                    </nz-select>
                </div>
            </div>
            <div class="row" *ngIf="volumeType === ArchiveVolumeType.REGULAR">
                <div class="column background-page" [style.textAlign]="'center'" [style.height]="120 + 'px'"
                    [style.width]="100 + 'px'">
                    表单代号<br />
                    排序设置
                </div>
                <div class="column background-module" [style.width]="600 + 'px'" [style.height]="120 + 'px'">
                    <nz-select [nzDisabled]="!fileOrderEnabled" [(ngModel)]="fileOrder" [nzOptions]="fileCodeOrder"
                        nzMode="multiple" [nzPlaceHolder]="'请选择排序方式'" (ngModelChange)="onFileOrderSelected()">
                    </nz-select>
                </div>
            </div>
            <div class="row validate" *ngIf="record.createType === ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 案卷题名
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <input type="text" [(ngModel)]="record.title" placeholder="请输入案卷题名示例">
                </div>
            </div>
            <div class="row validate"
                *ngIf="record.createType === ArchiveVolumeCreateType.MANUAL && volumeType !== ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 卷内文件
                </div>
                <div class="column background-module" [style.width]="300 + 'px'">
                    <select [(ngModel)]="record.fileRule">
                        <option [value]="undefined" [disabled]="true">选择卷内文件规则</option>
                        <option [value]="ArchiveVolumeFileRule.FULL_FILES">
                            {{ArchiveVolumeFileRuleMap[ArchiveVolumeFileRule.FULL_FILES]}}
                        </option>
                        <option [value]="ArchiveVolumeFileRule.MANUAL_SELECT">
                            {{ArchiveVolumeFileRuleMap[ArchiveVolumeFileRule.MANUAL_SELECT]}}
                        </option>
                    </select>
                </div>
                <div class="column background-page {{record.fileRule !== ArchiveVolumeFileRule.FULL_FILES ? 'color-light' : ''}}"
                    [style.width]="80 + 'px'">
                    起止日期
                </div>
                <div class="column {{record.fileRule !== ArchiveVolumeFileRule.FULL_FILES ? 'color-light' : ''}}"
                    [style.width]="100 + 'px'">
                    <nz-date-picker [(ngModel)]="record.fileFinishDateFromDate" [nzSuffixIcon]="''"
                        [nzFormat]="'yyyy-MM-dd'" [nzDisabled]="record.fileRule !== ArchiveVolumeFileRule.FULL_FILES"
                        [nzAllowClear]="true">
                    </nz-date-picker>
                </div>
                <div class="column {{record.fileRule !== ArchiveVolumeFileRule.FULL_FILES ? 'color-light' : ''}}"
                    [style.width]="20 + 'px'">
                    ~
                </div>
                <div class="column {{record.fileRule !== ArchiveVolumeFileRule.FULL_FILES ? 'color-light' : ''}}"
                    [style.width]="100 + 'px'">
                    <nz-date-picker [(ngModel)]="record.fileFinishDateToDate" [nzSuffixIcon]="''"
                        [nzFormat]="'yyyy-MM-dd'" [nzDisabled]="record.fileRule !== ArchiveVolumeFileRule.FULL_FILES"
                        [nzAllowClear]="true">
                    </nz-date-picker>
                </div>
            </div>
            <ng-container
                *ngIf="record.createType === ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="row" *ngFor="let single of unitCascaderValues; let index = index">
                    <div *ngIf="index === 0" class="column background-page spin wbs-section-label"
                        [style.width]="100 + 'px'" [style.height]="unitCascaderValues.length * 40 + 'px'">
                        卷内文件
                    </div>
                    <div class="column background-page" [style.width]="100 + 'px'"></div>
                    <div class="column background-module wbs-section-selector" [style.width]="600 + 'px'">
                        <nz-cascader [nzOptions]="unitCascaderOptions[index] || []" [ngModel]="single"
                            (ngModelChange)="onUnitCascaderChange(index, $event)" [nzShowSearch]="true"
                            nzPlaceHolder="请选择WBS部位">
                        </nz-cascader>
                    </div>
                </div>
            </ng-container>
            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page spin" [style.width]="30 + 'px'"
                    [style.height]="(autoCount + 3) * 40 + 'px'" [style.top]="0" [style.left]="0">
                    案 <br /> 卷 <br /> 题 <br /> 名
                </div>
                <div class="column background-page" [style.width]="30 + 'px'">

                </div>
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定前部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名前面固定部分（可以没有）" [(ngModel)]="titleRule.titleFixedPrefix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="30 + 'px'">

                </div>
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column background-page spin" [style.height]="autoCount * 40 + 'px'" [style.top]="0"
                    [style.left]="30 + 'px'" [style.width]="70 + 'px'">
                    自动部分
                </div>
                <div class="column background-page" [style.width]="100 + 'px'">
                    各级可参与项
                </div>
                <div class="column background-page" [style.textAlign]="'center'" [style.width]="60 + 'px'">
                    参与项<br />编号
                </div>
                <div class="column background-page" [style.width]="60 + 'px'">
                    示例
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    参与
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    间隔
                </div>
                <div class="column background-page" [style.textAlign]="'center'" [style.width]="60 + 'px'">
                    参与项<br />编号
                </div>
                <div class="column background-page" [style.width]="160 + 'px'">
                    示例
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    参与
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    间隔
                </div>
            </div>
            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'项目'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'104国道杭州河庄至衙前段'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.PROJECT + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.PROJECT + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.REGULAR">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'设计'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'SJ-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DESIGN + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DESIGN + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'杭州市交通规划设计研究院有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DESIGN + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DESIGN + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'监理'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'XSJL-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'杭州交通工程监理咨询有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'施工'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'EPC-02'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'浙江交工集团股份有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType !== ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'试验'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'SY-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SPOT_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SPOT_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'杭州市交通工程试验检测中心有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SPOT_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SPOT_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.REGULAR">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'交工'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'JGJC-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.JG_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.JG_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'中路高科交通检测检验认证有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.JG_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.JG_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.REGULAR">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'竣工'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'JG-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'绍兴市交科工程检测有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.MATERIAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'材料类型'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'材料名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'水泥'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_TYPE + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_TYPE + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.MATERIAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'规格型号'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'规格型号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'HPB300Φ10'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <!-- TODO -->
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_MODEL + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_MODEL + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.MATERIAL">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'年份'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'年份'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'2025'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_YEAR + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.MATERIAL_YEAR + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'单位工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'Q01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'主线高架桥(K4+658.396-K6+163.539)'"
                        [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分部工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'基础及下部构造（188#~200#墩）'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分部工程单元'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'02'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'188#墩'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分项工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'03'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'钻孔灌注桩'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分项工程单元'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'04'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'188-1#桩基'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>

            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分段'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'D1'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SEGMENT + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.SEGMENT + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
            </div>

            <div class="row"
                *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL && volumeType === ArchiveVolumeType.WBS">
                <div class="column background-page" [style.width]="100 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分层'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'C1'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.LAYER + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemDisplayType.LAYER + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
            </div>
            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="30 + 'px'">

                </div>
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定后部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名后面固定部分（可以没有）" [(ngModel)]="titleRule.titleFixedSuffix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row" *ngIf="record.createType !== ArchiveVolumeCreateType.MANUAL">
                <div class="column background-page" [style.width]="30 + 'px'">

                </div>
                <div class="column background-page" [style.width]="70 + 'px'">
                    卷名示例
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <pre class="color-primary">{{ exampleName }}</pre>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button *ngIf="!canBatch" nz-button nzType="primary" (click)="confirm(true)" class="large"
            [disabled]="!canConfirm">保存后继续分卷</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>